var map = {
	".": "336Z",
	"./": "336Z",
	"./01_listenKey": "gOrG",
	"./01_listenKey.json": "gOrG",
	"./02_balance": "Zg2x",
	"./02_balance.json": "Zg2x",
	"./03_order": "4X8p",
	"./03_order.json": "4X8p",
	"./04_setting": "M7Po",
	"./04_setting.json": "M7Po",
	"./index": "336Z",
	"./index.js": "336Z"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Pyy0";


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/swapV2/websocket/account ^.*$
// module id = Pyy0
// module chunks = 3